import { render, staticRenderFns } from "./SystemEmailHome.vue?vue&type=template&id=1cd07804&scoped=true"
import script from "./SystemEmailHome.vue?vue&type=script&lang=js"
export * from "./SystemEmailHome.vue?vue&type=script&lang=js"
import style0 from "./SystemEmailHome.vue?vue&type=style&index=0&id=1cd07804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd07804",
  null
  
)

export default component.exports